import { render } from "./person-update.vue?vue&type=template&id=1d25e42a"
import script from "./person-update.vue?vue&type=script&lang=js"
export * from "./person-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__